<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
    <toaster />
    <loading-overlay />
  </v-app>
</template>

<script>
import Toaster from '@/components/commons/Toaster'
import LoadingOverlay from '@/components/commons/LoadingOverlay'

export default {
  name: 'App',
  components: {
    Toaster,
    LoadingOverlay
  }
}
</script>
